var React = require('react');

function SocialFacebookHollow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"facebook"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M17.6,10.25a5.28,5.28,0,0,1,1.3.2l.4-2.39a10,10,0,0,0-2.88-.29A2.86,2.86,0,0,0,13.92,9a4.14,4.14,0,0,0-.51,2.4v1.57H11.8v2.32h1.61v8.09h3V15.24H18.8L19,12.92H16.42V11.1C16.42,10.48,17,10.25,17.6,10.25Z","transform":"translate(0)","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M15.55,0A15.55,15.55,0,1,0,31.1,15.55,15.55,15.55,0,0,0,15.55,0ZM19,12.92l-.18,2.32H16.42v8.09h-3V15.24H11.8V12.92h1.61V11.35A4.14,4.14,0,0,1,13.92,9a2.86,2.86,0,0,1,2.5-1.18,10,10,0,0,1,2.88.29l-.4,2.39a5.28,5.28,0,0,0-1.3-.2c-.62,0-1.18.23-1.18.85v1.82Z","transform":"translate(0)","key":1})])]);
}

SocialFacebookHollow.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 31.1 31.1"};

module.exports = SocialFacebookHollow;

SocialFacebookHollow.default = SocialFacebookHollow;
